import { ArticleOrderDraft, ItemOrderDraft, OrderStocks } from '../../../domain/Order';
import Product from '../../../domain/Product';

export default (
    orders: ArticleOrderDraft[],
    product: Product,
    sku: string,
    variantCode: string,
    value: number,
    field: keyof OrderStocks
): ArticleOrderDraft[] => {
    let itemUpdated = false;
    const articleOrderToUpdate: ArticleOrderDraft = orders.find((a: ArticleOrderDraft) => a.articleId === product.articleId)!;
    const itemsOrders: ItemOrderDraft[] = articleOrderToUpdate.itemsOrdersDrafts.map((itemOrder: ItemOrderDraft) => {
        if (itemOrder.sku === sku) {
            itemUpdated = true;
            return {
                ...itemOrder,
                [field]: value
            };
        }
        return itemOrder;
    });
    if (!itemUpdated) {
        itemsOrders.push({
            sku,
            variantCode,
            toOrderFromEstimation: 0,
            toOrderFromStock: 0,
            [field]: value
        });
    }
    return orders.map(
        (order: ArticleOrderDraft): ArticleOrderDraft => {
            if (order.articleId === product.articleId) {
                return {
                    ...order,
                    itemsOrdersDrafts: itemsOrders
                };
            }
            return order;
        }
    );
};



// WEBPACK FOOTER //
// ./src/application/order/reducer/updateArticleOrder.ts